import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

const ForeignBusinessIntro = function () {
  return (
    <div>
      <h1 className="section-header">{i18n.t('foreign.pvq.business.intro.title')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('foreign.pvq.business.intro.intro')}
        {i18n.m('foreign.pvq.business.intro.prefix')}
        <ul>
          <li>{i18n.m('foreign.pvq.business.intro.introItem1')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem2')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem3')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem4')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem5')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem6')}</li>
          <li>{i18n.m('foreign.pvq.business.intro.introItem7')}</li>
        </ul>
      </Field>
    </div>
  );
};

export default ForeignBusinessIntro;
